import $ from 'jquery'
import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'
import { showToast } from '@/utils/notifications';

import axios from "axios";

export default {
    name: 'confirm-sharing',
    components: {
        ResultatPatient
    },
    props: {
        data_type: String,
        evolution_id: Number,
        sharing_label: String,
        sharing_target: Object,
        r_toggler: Number,
        info_patient: Object,
        modal_id: String
    },
    data() {
        return {
            is_confirm: false,
            share_loading: false,
            results: {},
            result_filename: "",
            share_result_loading: false,
            loading_result: true
        }
    },

    watch: {
        r_toggler() {
            this.share_result_loading = false
            this.is_confirm = false
            this.setResultToShare()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        /**
         * Cache le message d'erreur au click du checkbox
        */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        setResultToShare() {
            const prefix = this.setFilenamePrefix()
            this.result_filename = prefix+this.info_patient.nom_patient+'_'+this.sharing_target.nom
            

            if (this.data_type == 'analyse_bio') {
                this.loading_result = true
                const param = {
                    analyseId: this.sharing_target.analyse_id,
                    bulletinId: this.sharing_target.bulletin_id
                }
                
                this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                    this.results = response.data;
                    this.loading_result = false
                })
            } else if (this.data_type == 'imagerie_medicale') {
                this.loading_result = false
            }
        },

        setFilenamePrefix() {
            let prefix = ""
            switch(this.data_type) {
                case 'analyse_bio':
                    prefix = "Resultat_Analyse_"
                    break
                case 'imagerie_medicale':
                    prefix = "Resultat_Examen_"
                    break
                default:
                    prefix = ""
            }
            return prefix
        },

        shareResult(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { 
                $('.err-msg').fadeIn(500)
                return
            }

            console.log("First")
            this.share_result_loading = true
            if (this.data_type == 'analyse_bio') {
                this.handleConfirmSharing()
            } else if (this.data_type == 'imagerie_medicale') {
                this.shareImagerieMedicaleResult()
            }
        },

        async beforeAnalyseDownload({ html2pdf, options, pdfContent }) {
            console.log("1")
            this.share_result_loading = true
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then(async (pdf) => {
                    const filename = this.result_filename + '.pdf';
                    const file = new File([pdf.output('blob')], filename, { type: 'application/pdf' });
                    

                    if (this.share_result_loading && this.results) {
                        const formData = new FormData();
                        formData.append('file', file);
                        
                        const baseUrl = this.C_URL + this.C_URL_CLINIQUE_API;
                        const path = `${baseUrl}/cca-mobile/analyses-bio-results/${this.sharing_target.demande_id}/share`;

                        try {
                            const response = await axios.post(path, formData);

                            if (response && response.status === 200) {
                                showToast("Résultat d'analyse partagé avec succès");
                            }
                        } catch (error) {
                            if (error.response) {
                                if (error.response.status === 400 || error.response.status === 422) {
                                    showToast("Erreur de requête", 'error');
                                } else if (error.response.status === 500) {
                                    showToast("Une erreur s'est produite, veuillez réessayer plus tard", 'error');
                                }
                            }
                        } finally {
                            this.share_result_loading = false;
                            $('.modal').modal('hide');
                        }
                    } 
                });
        },

        handleConfirmSharing() {
            console.log("2")
            this.share_result_loading = true
            this.$refs.share2pdf.generatePdf();  // Générez le PDF et envoyez-le
        },

        shareImagerieMedicaleResult() {
            this.share_result_loading = true
            const data = {
                demandes: [this.sharing_target.demande_id],
                nom: this.sharing_target.nom,
                reference: this.sharing_target.reference
            }

            this.$store.dispatch('shareResultatImagerieMedicale', data)
                .then((response) => {
                    console.log("Response imagerie share", response)
                    if (response && response.success) {
                        this.$refs.result_sharer.click()
                        showToast("Résultat d'imagerie médicale partagé avec succès")
                    } else {
                        showToast("Une erreur s'est produite", 'error')
                    }
                })
                .catch((error) => {
                    const status = error?.response?.status
                    if (status === 400 || status === 422) {
                        showToast("Erreur de requête", 'error')
                    } else {
                        showToast("Une erreur s'est produite, veuillez réessayer plus tard", 'error')
                    }
                })
                .finally(() => {
                    this.share_result_loading = false
                })
        }
    }
}